import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import apiClient from "../client";
import { SIGNALS_KEY } from "./useSignals";

const FOLLOWED_STRATEGIES_KEY = ["followed-strategies"] as const;

export interface FollowedStrategiesChange {
  follow: string[];
  unfollow: string[];
}

interface FollowedStrategiesResponse {
  tradingStrategyIds: string[];
}

/** The ids of the strategies the customer follows. */
export function useFollowedStrategies() {
  return useQuery<string[]>({
    queryKey: FOLLOWED_STRATEGIES_KEY,
    queryFn: async () => {
      const res = await apiClient.get<FollowedStrategiesResponse>("/customers/me/followed-strategies");
      return res.data.tradingStrategyIds;
    },
  });
}

/** Starts and stops following in one save, as the customer reviewed it. */
export function useSaveFollowedStrategies() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (change: FollowedStrategiesChange) => {
      const res = await apiClient.put<FollowedStrategiesResponse>("/customers/me/followed-strategies", change);
      return res.data.tradingStrategyIds;
    },
    onSuccess: (tradingStrategyIds) => {
      queryClient.setQueryData<string[]>(FOLLOWED_STRATEGIES_KEY, tradingStrategyIds);
      return queryClient.invalidateQueries({ queryKey: SIGNALS_KEY });
    },
  });
}
